import React from 'react';
import { useStore } from '../../app/stores/store';
import { observer } from 'mobx-react-lite';
import { Container, Header, Segment } from 'semantic-ui-react';

const ServerError: React.FC = observer(() => {
  const { commonStore } = useStore();

  return (
    <Container>
      <Header as="h1" content="Server Error" />
      <Header sub as="h5" color="red" content={commonStore.error?.message} />
      {commonStore.error?.details && (
        <Segment>
          <Header as="h4" content="Stack trace:" color="teal" />
          <code style={{ marginTop: '12px' }}>{commonStore.error.details}</code>
        </Segment>
      )}
    </Container>
  );
});

export { ServerError };
